import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer-mobile',
    templateUrl: 'footer-mobile.component.html',
    styles: [],
    standalone: false
})
export class FooterMobileComponent {
  constructor(private router:Router) {}
  redirectToSchedule(){
    this.router.navigate(['/schedule-mobile'])
  }
}
